import { Home } from "lucide-react";
import { AiOutlinePieChart } from "react-icons/ai";
// import { BiBullseye } from "react-icons/bi";
import {
  FaGlobeAmericas, //   FaRegArrowAltCircleLeft,
  //   FaRegFileAlt,
} from "react-icons/fa";
import { FaRegAddressCard } from "react-icons/fa6";
import { GiWindTurbine } from "react-icons/gi";
import { IoCardOutline, IoClipboardOutline } from "react-icons/io5";
import {
  MdLightbulbOutline,
  MdOutlineFormatListBulleted, // MdOutlineFormatListBulleted,
  MdOutlineHealthAndSafety,
  MdOutlineInsertChartOutlined,
  MdOutlineShoppingBag,
} from "react-icons/md";
import { RiDoorOpenLine } from "react-icons/ri";
import { TbZoomScan } from "react-icons/tb";
import { Icon } from "~/components/ui";

type SubNavItem = {
  title: string;
  path: string;
};

type NavIconProps = {
  size?: string | number | undefined;
  className?: string | undefined;
  color?: string | undefined;
};

type NavTopOrBottomItem = {
  collapsed?: boolean;
};

interface NavItem {
  title: string;
  icon?: string;
  navIcon: ({ size, className, color }: NavIconProps) => JSX.Element;
  navTopComponent?: ({ collapsed }: NavTopOrBottomItem) => JSX.Element;
  navBottomComponent?: ({ collapsed }: NavTopOrBottomItem) => JSX.Element;
  path?: string;
  subItems?: SubNavItem[];
  id?: string;
}

export const navigationItems: NavItem[] = [
  /*
   * 8th June, 2026
   * TODO: Remove this code - kept temporarily for reference and will be removed
   * when all new reporting package has been fully confirmed functioning with issues
   */
  // {
  //   title: "Reports Old",
  //   icon: "reports-test-icon",
  //   navIcon: ({ size, className, color }: NavIconProps) => (
  //     <MdOutlineInsertChartOutlined
  //       size={size}
  //       className={className}
  //       color={color}
  //     />
  //   ),
  //   path: "/reports-old",
  // },
  {
    title: "Dashboard",
    icon: "home-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <Home size={size} className={className} color={color} />
    ),
    path: "/hse/home",
  },
  {
    title: "Reports",
    icon: "reports-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdOutlineInsertChartOutlined
        size={size}
        className={className}
        color={color}
      />
    ),
    path: "/hse/reports",
  },
  {
    title: "Marketplace",
    icon: "marketplace-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdOutlineShoppingBag size={size} className={className} color={color} />
    ),
    path: "/marketplace",
  },
  {
    title: "Sites",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdOutlineFormatListBulleted
        size={size}
        className={className}
        color={color}
      />
    ),
    path: "/hse/sites",
  },
  {
    title: "Incidents",
    icon: "incidents-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdLightbulbOutline size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Item Management
          </div>
        )}
      </div>
    ),
    path: "/hse/incidents",
  },
  {
    title: "Observations",
    icon: "observations-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <Icon name="Target" size={size} className={className} color={color} />
    ),
    path: "/hse/observations",
  },
  {
    title: "Inspections",
    icon: "inspections-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <TbZoomScan size={size} className={className} color={color} />
    ),
    path: "/hse/inspections",
  },
  {
    title: "Audits",
    icon: "audits-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <AiOutlinePieChart size={size} className={className} color={color} />
    ),
    path: "/hse/audits",
  },

  {
    title: "People Permits",
    icon: "certifications-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoCardOutline size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Compliance Management
          </div>
        )}
      </div>
    ),
    subItems: [
      {
        title: "Eligibility",
        path: "/hse/compliance/personnel/eligibility-permits",
      },
      {
        title: "Competence",
        path: "/hse/compliance/personnel/competence-permits",
      },
    ],
  },
  {
    title: "Org Permits",
    icon: "regulations-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <FaGlobeAmericas size={size} className={className} color={color} />
    ),
    subItems: [
      {
        title: "Company-Wide",
        path: "/hse/compliance/organizational/company-wide-permits",
      },
      {
        title: "Site-Specific",
        path: "/hse/compliance/organizational/site-specific-permits",
      },
    ],
  },
  {
    title: "Environmental",
    icon: "environmental-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <GiWindTurbine size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Record Management
          </div>
        )}
      </div>
    ),
    path: "/hse/records/environmental",
  },
  {
    title: "Health",
    icon: "health-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdOutlineHealthAndSafety
        size={size}
        className={className}
        color={color}
      />
    ),
    path: "/hse/records/health",
  },
  {
    title: "Meeting",
    icon: "meeting-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <RiDoorOpenLine size={size} className={className} color={color} />
    ),
    path: "/hse/records/meeting",
  },
  {
    title: "Work Hours",
    icon: "man-hours-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/hse/records/work-hours",
  },
  {
    title: "Job Safety Analysis",
    icon: "jsa-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Daily Operations
          </div>
        )}
      </div>
    ),
    path: "/daily-ops/jsa",
  },
  {
    title: "COSHH Assessment",
    icon: "coshh-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/daily-ops/coshh",
  },
  {
    title: "Dynamic Risk Assessment",
    icon: "dra-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/daily-ops/dra",
  },
  {
    title: "Permit to Work",
    icon: "ptw-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/daily-ops/ptw",
  },
  {
    title: "Lifting Operations",
    icon: "lifting-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/daily-ops/lifting-operations",
  },
  {
    title: "General Inventory",
    icon: "inventory-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoCardOutline size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Inventory
          </div>
        )}
      </div>
    ),
    path: "/resource/inventory/general",
  },
  {
    title: "Health Inventory",
    icon: "health-inventory-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <MdOutlineHealthAndSafety
        size={size}
        className={className}
        color={color}
      />
    ),
    path: "/resource/inventory/health",
  },
  {
    title: "Risk Register",
    icon: "list-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Register
          </div>
        )}
      </div>
    ),
    path: "/resource/registers/risk",
  },
  {
    title: "Chemical Register",
    icon: "list-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/resource/registers/chemical",
  },
  {
    title: "Control Library",
    icon: "list-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <IoClipboardOutline size={size} className={className} color={color} />
    ),
    path: "/resource/registers/controls",
  },
  {
    title: "Employees",
    icon: "employees-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <FaRegAddressCard size={size} className={className} color={color} />
    ),
    navTopComponent: ({ collapsed }) => (
      <div className="mx-auto w-9/12 pt-8">
        {!collapsed && (
          <div className="pb-3 text-xs uppercase tracking-wide text-[#2CD5C7]">
            Employees
          </div>
        )}
      </div>
    ),
    path: "/resource/employees",
  },
  {
    title: "Assets",
    icon: "assets-icon",
    navIcon: ({ size, className, color }: NavIconProps) => (
      <Icon name="Layers" size={size} className={className} color={color} />
    ),
    path: "/asset/assets",
  },
];
